// Generated by CoffeeScript 1.9.3
var PaddingTop, _Length,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

_Length = require('./_Length');

module.exports = PaddingTop = (function(superClass) {
  extend(PaddingTop, superClass);

  function PaddingTop() {
    return PaddingTop.__super__.constructor.apply(this, arguments);
  }

  return PaddingTop;

})(_Length);



//////////////////
// WEBPACK FOOTER
// ./~/renderkid/lib/renderKid/styles/rule/declarationBlock/PaddingTop.js
// module id = 1772
// module chunks = 0